import { tGlob } from "@/app/[lang]/_t-glob/t-glob";
import { env } from "@/env";
import type { Lang } from "@/langs";
import { Button } from "@borderless/ui/components/button";
import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
} from "@borderless/ui/components/navigation-menu";
import {
  Sheet,
  SheetContent,
  SheetFooter,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@borderless/ui/components/sheet";
import { ThemeSelector } from "@borderless/ui/components/theme-selector";
import { Menu02 } from "@borderless/ui/icons";
import BorderlessLong from "@borderless/ui/icons/BorderlessLong";
import { GoToAppButton } from "./GoToAppButton";
import { LanguageSwitcher } from "./LanguageSwitcher";
import Link from "./Link";
export function HeaderNav(props: { lang: Lang }) {
  return (
    <header className="sticky top-0 z-40 flex h-(--header-height) items-center border-b border-border bg-background px-4">
      <div className="flex-1">
        <Link href="/">
          <BorderlessLong className="block h-[1.125rem] shrink-0" />
        </Link>
      </div>

      <Sheet>
        <SheetTrigger asChild>
          <Button variant="ghost" size="icon" className="sm:hidden">
            <Menu02 />
          </Button>
        </SheetTrigger>
        <SheetContent className="p-(--main-padding)">
          <SheetHeader>
            <SheetTitle hidden>Borderless</SheetTitle>
            <GoToAppButton
              size="sm"
              className="mx-auto w-fit"
              lang={props.lang}
            />
          </SheetHeader>

          <Button variant="link" size="sm" asChild>
            <a href={env.NEXT_PUBLIC_WORKSPACE_BASE_URL}>
              {tGlob("Borderless App", props.lang)}
            </a>
          </Button>

          <Button variant="link" size="sm" asChild>
            <Link href="/stories">{tGlob("Stories", props.lang)}</Link>
          </Button>

          <SheetFooter>
            <LanguageSwitcher lang={props.lang} />
            <ThemeSelector />
          </SheetFooter>
        </SheetContent>
      </Sheet>

      <NavigationMenu
        viewport={false}
        className="hidden text-foreground **:text-sm sm:flex"
      >
        <NavigationMenuList className="gap-4">
          <NavigationMenuItem>
            <NavigationMenuLink asChild>
              <a href={env.NEXT_PUBLIC_WORKSPACE_BASE_URL}>
                {tGlob("Borderless App", props.lang)}
              </a>
            </NavigationMenuLink>
          </NavigationMenuItem>
          <NavigationMenuItem>
            <NavigationMenuLink asChild>
              <Link href="/stories">{tGlob("Stories", props.lang)}</Link>
            </NavigationMenuLink>
          </NavigationMenuItem>
        </NavigationMenuList>
      </NavigationMenu>
      <div className="hidden flex-1 items-center justify-end gap-0 sm:flex md:gap-2">
        <LanguageSwitcher lang={props.lang} className="hidden md:inline-flex" />
        <GoToAppButton size="sm" lang={props.lang} />
      </div>
    </header>
  );
}
